const Label=({text})=>
{
    return(
            <p style={{fontFamily:"Poppins"}} className="z-10 sm:text-[34px] lg:text-[50px] text-[#0C0C0C] font-[600] sm:leading-[30px] lg:leading-[60px] text-center">{text}</p>

    )
}
export default Label